import {
  LayoutDashboard, Package, UtensilsCrossed, BookOpen, Warehouse, ClipboardList,
  Factory, Truck, TrendingUp, Calendar, ChefHat, Layers, Box, DollarSign, Thermometer,
} from 'lucide-react';
import { Permission } from '@/types/auth';
import { type NavItem } from './navigation-types';

export const operationsNavItems: NavItem[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    href: '/',
    icon: LayoutDashboard 
  },
  {
    id: 'catalog',
    label: 'Catalog',
    href: '/catalog',
    icon: Package,
    permissions: [Permission.VIEW_CATALOG],
    children: [
      {
        id: 'catalog-items',
        label: 'Items',
        href: '/catalog/items',
        icon: Package,
        permissions: [Permission.VIEW_CATALOG] 
      },
      {
        id: 'catalog-categories',
        label: 'Categories',
        href: '/catalog/categories',
        icon: Package,
        permissions: [Permission.VIEW_CATALOG] 
      },
    ],
  },
  {
    id: 'recipes',
    label: 'Culinary',
    href: '/recipes',
    icon: UtensilsCrossed,
    permissions: [Permission.VIEW_RECIPES],
    children: [
      {
        id: 'recipes-menu-items',
        label: 'Menu Items',
        href: '/recipes/menu-items',
        icon: ChefHat,
        permissions: [Permission.VIEW_RECIPES] 
      },
      {
        id: 'recipes-sub',
        label: 'Sub-Recipes',
        href: '/recipes/sub-recipes',
        icon: Layers,
        permissions: [Permission.VIEW_RECIPES] 
      },
      {
        id: 'recipes-components',
        label: 'Components',
        href: '/recipes/components',
        icon: Box,
        permissions: [Permission.VIEW_RECIPES] 
      },
      {
        id: 'recipes-costing',
        label: 'Costing',
        href: '/recipes/costing',
        icon: DollarSign,
        permissions: [Permission.VIEW_RECIPES] 
      },
    ],
  },
  {
    id: 'menus',
    label: 'Menus',
    href: '/menus',
    icon: BookOpen,
    permissions: [Permission.VIEW_MENUS],
    children: [
      {
        id: 'menus-overview',
        label: 'Overview',
        href: '/menus',
        icon: BookOpen,
        permissions: [Permission.VIEW_MENUS] 
      },
      {
        id: 'menus-calendar',
        label: 'Calendar',
        href: '/menus/calendar',
        icon: Calendar,
        permissions: [Permission.VIEW_MENUS] 
      },
      {
        id: 'menus-forecast',
        label: 'Demand Forecast',
        href: '/menus/forecast',
        icon: TrendingUp,
        permissions: [Permission.VIEW_MENUS] 
      },
    ],
  },
  {
    id: 'inventory',
    label: 'Inventory',
    href: '/inventory',
    icon: Warehouse,
    permissions: [Permission.VIEW_INVENTORY],
    children: [
      {
        id: 'inventory-stock',
        label: 'Stock Levels',
        href: '/inventory/stock',
        icon: Warehouse,
        permissions: [Permission.VIEW_INVENTORY] 
      },
      {
        id: 'inventory-storage',
        label: 'Storage',
        href: '/inventory/storage',
        icon: Thermometer,
        permissions: [Permission.VIEW_INVENTORY] 
      },
      {
        id: 'inventory-transfers',
        label: 'Transfers',
        href: '/inventory/transfers',
        icon: Warehouse,
        permissions: [Permission.TRANSFER_INVENTORY] 
      },
      {
        id: 'inventory-counts',
        label: 'Cycle Counts',
        href: '/inventory/counts',
        icon: ClipboardList,
        permissions: [Permission.MANAGE_INVENTORY] 
      },
    ],
  },
  {
    id: 'requisitions',
    label: 'Requisitions',
    href: '/requisitions',
    icon: ClipboardList,
    permissions: [Permission.VIEW_REQUISITIONS],
    children: [
      {
        id: 'requisitions-create',
        label: 'Create Request',
        href: '/requisitions/create',
        icon: ClipboardList,
        permissions: [Permission.CREATE_REQUISITIONS] 
      },
      {
        id: 'requisitions-pending',
        label: 'Pending Approval',
        href: '/requisitions/pending',
        icon: ClipboardList,
        permissions: [Permission.APPROVE_REQUISITIONS] 
      },
      {
        id: 'requisitions-picks',
        label: 'Pick Lists',
        href: '/requisitions/picks',
        icon: ClipboardList,
        permissions: [Permission.VIEW_REQUISITIONS] 
      },
    ],
  },
  {
    id: 'production',
    label: 'Production',
    href: '/production',
    icon: Factory,
    permissions: [Permission.VIEW_PRODUCTION],
    children: [
      {
        id: 'production-prep',
        label: 'Prep Lists',
        href: '/production/prep',
        icon: Factory,
        permissions: [Permission.VIEW_PRODUCTION] 
      },
      {
        id: 'production-batch',
        label: 'Batch Planning',
        href: '/production/batch',
        icon: Factory,
        permissions: [Permission.MANAGE_PRODUCTION] 
      },
    ],
  },
  {
    id: 'receiving',
    label: 'Receiving',
    href: '/receiving',
    icon: Truck,
    permissions: [Permission.VIEW_RECEIVING],
    children: [
      {
        id: 'receiving-expected',
        label: 'Expected Deliveries',
        href: '/receiving/expected',
        icon: Truck,
        permissions: [Permission.VIEW_RECEIVING] 
      },
      {
        id: 'receiving-goods',
        label: 'Receive Goods',
        href: '/receiving/goods',
        icon: Truck,
        permissions: [Permission.RECEIVE_GOODS] 
      },
      {
        id: 'receiving-discrepancies',
        label: 'Discrepancies',
        href: '/receiving/discrepancies',
        icon: Truck,
        permissions: [Permission.VIEW_RECEIVING] 
      },
    ],
  },
];
